import { Component, OnInit, ViewChild } from "@angular/core";
import { MatPaginator } from "@angular/material/paginator";
import { MatSnackBar, MatSnackBarConfig } from "@angular/material/snack-bar";
import { MatSort } from "@angular/material/sort";
import { MatTableDataSource } from "@angular/material/table";
import { ReportsService } from "src/app/_Reports/services/reports.service";
import { DataSharingService } from "../../AuthGuard/DataSharingService";
import { MasterService } from "../../Shared/app.Masters.Service";
import { SnackbarComponent } from "../../snackbar/snackbar.component";
import { ActivatedRoute, Params } from "@angular/router";
import { LmsService } from "../../_Lms/services/lms.service";
import * as moment from "moment";
declare var $: any;

@Component({
  selector: 'app-unauthorized-vouchers',
  templateUrl: './unauthorized-vouchers.component.html',
  styleUrls: ['./unauthorized-vouchers.component.scss'],
  standalone: false
})
export class UnauthorizedVouchersComponent implements OnInit {
  currentUser: any;
  activeTab: 'individual' | 'batch' = 'individual';
  // StartDate: any = "";
  EndDate: any = "";
  VoucherType: any = "";
  VoucherSubType: any = "";
  AmountFrom: any = null;
  AmountTo: any = null;
  dataSource: any;
  showSpinner: boolean = false;
  displayedColumnsModel: any;
  JsonData: any[] = [];
  SelectAll: any;
  IsSelected: boolean = false;
  configSuccess: MatSnackBarConfig = {
    panelClass: "style-success",
    duration: 5000,
    horizontalPosition: "right",
    verticalPosition: "top",
  };
  Status: any = "";
  AuthorizeRemark: any;
  RejectRemark: any;
  FyearId: any;
  maxDate: any;
  minDate: any;
  StartDate: any = new Date(
    new Date().getFullYear(),
    new Date().getMonth(),
    1
  );

  @ViewChild('paginator') paginator!: MatPaginator;
  @ViewChild('sort') sort!: MatSort;

  // Batch Wise Properties
  batchDataSource: any;
  batchSummaryList: any[] = [];
  batchDisplayedColumns: string[] = [
    "SrNo",
    "Batch_no",
    "Voucher_CreateBy",
    "VoucherIdCount",
    "Voucher_CreateOn",
    "Action",
  ];
  @ViewChild('batchPaginator') batchPaginator!: MatPaginator;
  @ViewChild('batchSort') batchSort!: MatSort;

  // Batch Voucher Details Modal properties
  showBatchDetailsModal: boolean = false;
  selectedBatchRow: any = null;
  batchSummaryHeader: any = {};
  batchVoucherDetailsList: any[] = [];
  batchDetailsDataSource: any;
  batchActionRemark: string = '';

  constructor(
    private dataSharingService: DataSharingService,
    public snackBar: MatSnackBar,
    private MasterService: MasterService,
    private ReportsService: ReportsService,
    private lmsService: LmsService,
    private route: ActivatedRoute,
  ) { }

  ngOnInit(): void {
    this.dataSharingService.HeaderTitle.next("Unauthorized Vouchers");
    this.currentUser = JSON.parse(sessionStorage.getItem("currentUser"));

    this.route.queryParams.subscribe((params) => {
      this.FyearId = params["fyear"];
      console.log("paran", this.FyearId);
      this.lmsService
        .Get_FinancialYear({ Id: this.FyearId })
        .subscribe((res: any) => {
          this.minDate = new Date(moment(res[0].fystart).format("MM/DD/YYYY"));
          this.maxDate = new Date(moment(res[0].fyent).format("MM/DD/YYYY"));

          if (this.maxDate > new Date() && this.minDate < new Date()) {
            this.EndDate = new Date();
          } else {
            this.EndDate = this.maxDate;
          }
          this.dataSource = null;
        });
    });
  }

  getFyearId(): number {
    const queryParamFyear = this.route.snapshot.queryParams["fyear"];
    if (queryParamFyear && parseInt(queryParamFyear, 10) > 0) {
      return parseInt(queryParamFyear, 10);
    }
    const sessionFyear = sessionStorage.getItem("FyearId");
    if (sessionFyear && parseInt(JSON.parse(sessionFyear), 10) > 0) {
      return parseInt(JSON.parse(sessionFyear), 10);
    }
    return Number(this.FyearId) || 0;
  }

  selectTab(tab: 'individual' | 'batch') {
    this.activeTab = tab;
    if (tab === 'batch' && (!this.batchSummaryList || this.batchSummaryList.length === 0)) {
      this.onSearchBatch();
    }
  }

  onSearchBatch(): void {
    this.showSpinner = true;
    const fyearIdNum = this.getFyearId();
    this.FyearId = fyearIdNum;

    const requestData = {
      EmpId: this.currentUser?.userId || 0,
      fyearId: fyearIdNum,
    };

    this.ReportsService.Get_UnAuth_Voucher_BatchWise(requestData).subscribe({
      next: (res: any) => {
        this.showSpinner = false;
        let data = res;
        if (typeof res === "string") {
          try {
            data = JSON.parse(res);
          } catch (e) {
            data = res;
          }
        }

        this.batchSummaryList = Array.isArray(data)
          ? data
          : data?.data || data?.List || data?.Table || [];
        this.batchDataSource = new MatTableDataSource(this.batchSummaryList);
        setTimeout(() => {
          if (this.batchPaginator) this.batchDataSource.paginator = this.batchPaginator;
          if (this.batchSort) this.batchDataSource.sort = this.batchSort;
        });
      },
      error: (err: any) => {
        this.showSpinner = false;
        console.error("Error fetching Get_UnAuth_Voucher_BatchWise:", err);
      },
    });
  }

  applyBatchFilter(filterValue: string): void {
    if (this.batchDataSource) {
      this.batchDataSource.filter = filterValue.trim().toLowerCase();
    }
  }

  formatDateOnly(dateVal: any): string {
    if (!dateVal) return "";
    const str = String(dateVal).trim();
    if (str.includes(" ")) {
      return str.split(" ")[0];
    }
    if (str.includes("T")) {
      return str.split("T")[0];
    }
    return str;
  }

  onViewBatchDetail(row: any): void {
    if (!row || !row.Batch_no) return;
    this.showSpinner = true;
    this.selectedBatchRow = row;
    this.ReportsService
      .Get_UnAuth_Voucher_detail_BatchWise({ Batch_no: row.Batch_no })
      .subscribe({
        next: (res: any) => {
          this.showSpinner = false;
          let data = res;
          if (typeof res === "string") {
            try {
              data = JSON.parse(res);
            } catch (e) {
              data = res;
            }
          }

          const headerObj =
            data?.Item1 && data.Item1.length > 0
              ? data.Item1[0]
              : data?.item1 && data.item1.length > 0
              ? data.item1[0]
              : {};
          this.batchSummaryHeader = {
            ...row,
            ...headerObj,
            Voucher_No: headerObj.Voucher_No || row.Batch_no,
            Voucher_Date: headerObj.Voucher_Date || row.Voucher_CreateOn,
          };

          let detailsRaw: any[] = data?.Item2 || data?.item2 || [];

          const getVoucherKey = (item: any): string => {
            if (!item) return "";
            const candidates = [
              item.VoucherId,
              item.Voucher_Id,
              item.VoucherNo,
              item.Voucher_No,
              item.VoucherID,
              item.voucherId,
              item.voucher_id,
              item.Voucher_no,
              item.voucherNo,
              item.voucher_No,
              item.Bind_Voucher,
              item.Voucher,
            ];
            for (const c of candidates) {
              if (c !== undefined && c !== null) {
                const s = String(c).trim();
                if (s.length > 0 && s !== "0") {
                  return s;
                }
              }
            }
            return "";
          };

          const rawVoucherIds =
            (row && (row.VoucherIds || row.Voucher_Ids || row.VoucherId)) ||
            (this.batchSummaryHeader &&
              (this.batchSummaryHeader.VoucherIds ||
                this.batchSummaryHeader.Voucher_Ids ||
                this.batchSummaryHeader.VoucherId)) ||
            (headerObj &&
              (headerObj.VoucherIds ||
                headerObj.Voucher_Ids ||
                headerObj.VoucherId)) ||
            "";

          const batchVoucherOrder: string[] = String(rawVoucherIds)
            .split(",")
            .map((id: string) => id.trim())
            .filter((id: string) => id.length > 0);

          const getTranTypeRank = (tranType: any): number => {
            const t = String(tranType || "")
              .trim()
              .toUpperCase();
            if (t === "DR") return 1;
            if (t === "CR") return 2;
            return 3;
          };

          const groupsMap = new Map<
            string,
            { key: string; items: any[]; firstIndex: number }
          >();
          const unassigned: any[] = [];

          detailsRaw.forEach((item: any, originalIndex: number) => {
            const key = getVoucherKey(item);
            if (key) {
              if (!groupsMap.has(key)) {
                groupsMap.set(key, {
                  key,
                  items: [],
                  firstIndex: originalIndex,
                });
              }
              groupsMap.get(key)!.items.push(item);
            } else {
              unassigned.push(item);
            }
          });

          groupsMap.forEach((group) => {
            group.items.sort((a: any, b: any) => {
              const rankA = getTranTypeRank(a.TranType);
              const rankB = getTranTypeRank(b.TranType);
              if (rankA !== rankB) return rankA - rankB;
              return (Number(a.Id) || 0) - (Number(b.Id) || 0);
            });
          });

          const sortedGroups = Array.from(groupsMap.values());
          sortedGroups.sort((gA, gB) => {
            if (batchVoucherOrder.length > 0) {
              const idxA = batchVoucherOrder.indexOf(gA.key);
              const idxB = batchVoucherOrder.indexOf(gB.key);
              if (idxA !== -1 && idxB !== -1) return idxA - idxB;
              if (idxA !== -1) return -1;
              if (idxB !== -1) return 1;
            }

            const numA = Number(gA.key);
            const numB = Number(gB.key);
            if (!isNaN(numA) && !isNaN(numB)) {
              return numA - numB;
            }
            return gA.firstIndex - gB.firstIndex;
          });

          const finalDetailsList: any[] = [];
          let groupIndex = -1;

          sortedGroups.forEach((g) => {
            if (!g.items || g.items.length === 0) return;
            groupIndex++;
            const groupClass =
              groupIndex % 2 === 0 ? "voucher-group-even" : "voucher-group-odd";

            let groupSumDR = 0;
            let groupSumCR = 0;

            g.items.forEach((item: any) => {
              const tType = String(item.TranType || "")
                .trim()
                .toUpperCase();
              const rawAmt = Number(item.Amount) || 0;
              const amountDR =
                tType === "DR" ? rawAmt : Number(item.AmountDR) || 0;
              const amountCR =
                tType === "CR" ? rawAmt : Number(item.AmountCR) || 0;

              groupSumDR += amountDR;
              groupSumCR += amountCR;

              finalDetailsList.push({
                ...item,
                isGroupTotal: false,
                CaseNo: item.CaseNo || "-",
                Customer: item.Customer || "-",
                Branch_Name: item.Branch_Name || "-",
                ChagesHead: item.ChagesHead || item.ChargeHeadCategory || "-",
                Account_Name:
                  item.Party_AccountName || item.Account_Name || item.ChargeHeadCategory || "-",
                AmountDR: amountDR,
                AmountCR: amountCR,
                groupClass: groupClass,
              });
            });

            const rawGroupVoucherDate =
              g.items[0]?.Voucher_Date ||
              g.items[0]?.VoucherDate ||
              g.items[0]?.Voucher_CreateOn ||
              g.items[0]?.Date ||
              this.batchSummaryHeader?.Voucher_Date ||
              this.batchSummaryHeader?.Voucher_CreateOn ||
              "";

            const groupVoucherDate = this.formatDateOnly(rawGroupVoucherDate);

            finalDetailsList.push({
              isGroupTotal: true,
              Voucher_No: "",
              TranType: "",
              CaseNo: "",
              Customer: "",
              Branch_Name: "",
              ChagesHead: "",
              Account_Name: "Total",
              Voucher_Date: groupVoucherDate,
              AmountDR: groupSumDR,
              AmountCR: groupSumCR,
              groupClass: "voucher-group-subtotal-row",
            });
          });

          if (unassigned.length > 0) {
            groupIndex++;
            const groupClass =
              groupIndex % 2 === 0 ? "voucher-group-even" : "voucher-group-odd";

            let groupSumDR = 0;
            let groupSumCR = 0;

            unassigned.forEach((item: any) => {
              const tType = String(item.TranType || "")
                .trim()
                .toUpperCase();
              const rawAmt = Number(item.Amount) || 0;
              const amountDR =
                tType === "DR" ? rawAmt : Number(item.AmountDR) || 0;
              const amountCR =
                tType === "CR" ? rawAmt : Number(item.AmountCR) || 0;

              groupSumDR += amountDR;
              groupSumCR += amountCR;

              finalDetailsList.push({
                ...item,
                isGroupTotal: false,
                CaseNo: item.CaseNo || "-",
                Customer: item.Customer || "-",
                Branch_Name: item.Branch_Name || "-",
                ChagesHead: item.ChagesHead || item.ChargeHeadCategory || "-",
                Account_Name:
                  item.Party_AccountName || item.Account_Name || item.ChargeHeadCategory || "-",
                AmountDR: amountDR,
                AmountCR: amountCR,
                groupClass: groupClass,
              });
            });

            const rawUnassignedDate =
              unassigned[0]?.Voucher_Date ||
              unassigned[0]?.VoucherDate ||
              unassigned[0]?.Voucher_CreateOn ||
              unassigned[0]?.Date ||
              this.batchSummaryHeader?.Voucher_Date ||
              this.batchSummaryHeader?.Voucher_CreateOn ||
              "";

            const unassignedVoucherDate = this.formatDateOnly(rawUnassignedDate);

            finalDetailsList.push({
              isGroupTotal: true,
              Voucher_No: "",
              TranType: "",
              CaseNo: "",
              Customer: "",
              Branch_Name: "",
              ChagesHead: "",
              Account_Name: "Total",
              Voucher_Date: unassignedVoucherDate,
              AmountDR: groupSumDR,
              AmountCR: groupSumCR,
              groupClass: "voucher-group-subtotal-row",
            });
          }

          this.batchVoucherDetailsList = finalDetailsList;
          this.batchDetailsDataSource = new MatTableDataSource(this.batchVoucherDetailsList);
          this.showBatchDetailsModal = true;
          setTimeout(() => {
            $("#BatchVoucherDetailsModal").modal("show");
            $("#BatchVoucherDetailsModal").css("z-index", "9999");
          });
        },
        error: (err: any) => {
          this.showSpinner = false;
          console.error("Error fetching Get_UnAuth_Voucher_detail_BatchWise:", err);
        },
      });
  }

  onCloseBatchDetailsModal(): void {
    $("#BatchVoucherDetailsModal").modal("hide");
    this.showBatchDetailsModal = false;
  }

  calculateBatchTotalDR(): number {
    if (!this.batchVoucherDetailsList) return 0;
    return this.batchVoucherDetailsList.reduce(
      (sum, item) => sum + (item.isGroupTotal ? 0 : Number(item.AmountDR) || 0),
      0,
    );
  }

  calculateBatchTotalCR(): number {
    if (!this.batchVoucherDetailsList) return 0;
    return this.batchVoucherDetailsList.reduce(
      (sum, item) => sum + (item.isGroupTotal ? 0 : Number(item.AmountCR) || 0),
      0,
    );
  }

  PrintBatchDoc(
    divName: string = "BatchVoucherDetailPrint",
    Header: string = "Voucher Detail",
  ): void {
    const printElement = document.getElementById(divName);
    if (!printElement) return;

    const printContents = printElement.innerHTML;
    const popupWin = window.open("", "_blank", "width=1050,height=750");
    if (popupWin) {
      popupWin.document.open();
      popupWin.document.write(`
        <!DOCTYPE html>
        <html>
          <head>
            <title>${Header}</title>
            <style>
              body { font-family: 'Plus Jakarta Sans', Arial, sans-serif; font-size: 11px; margin: 20px; color: #333; }
              table { width: 100%; border-collapse: collapse; margin-top: 10px; font-size: 10px; }
              th, td { border: 1px solid #ccc; padding: 6px 8px; }
              th { background-color: #f2f2f2; font-weight: 600; text-align: left; }
              .fw-700, .fw-600 { font-weight: bold; }
              .text-left { text-align: left; }
              .text-right { text-align: right; }
              .amount-dr { color: #0d3853; }
              .amount-cr { color: #166534; }
              .voucher-total-row td { background-color: #e2e8f0; font-weight: bold; }
              .voucher-type-banner { padding: 8px 12px; background: #eaf1fa; border-left: 4px solid #0d3853; margin-bottom: 10px; }
              .voucher-meta-card { border: 1px solid #ddd; padding: 6px 10px; margin-bottom: 8px; }
              .no-print, .d-print-none { display: none !important; }
            </style>
          </head>
          <body onload="window.print(); window.close();">
            ${printContents}
          </body>
        </html>
      `);
      popupWin.document.close();
    }
  }

  onBatchDeleteFromDetail(): void {
    if (!this.batchActionRemark || this.batchActionRemark.trim() === "") {
      this.snackBar.openFromComponent(SnackbarComponent, {
        data: "Remark is required for deleting batch.",
        ...this.configSuccess,
      });
      return;
    }

    let rawVoucherIds =
      (this.batchSummaryHeader &&
        (this.batchSummaryHeader.VoucherIds ||
          this.batchSummaryHeader.Voucher_Ids ||
          this.batchSummaryHeader.VoucherId)) ||
      (this.selectedBatchRow &&
        (this.selectedBatchRow.VoucherIds ||
          this.selectedBatchRow.Voucher_Ids ||
          this.selectedBatchRow.VoucherId)) ||
      "";

    if (!rawVoucherIds && this.batchVoucherDetailsList && this.batchVoucherDetailsList.length > 0) {
      const idsSet = new Set<string>();
      this.batchVoucherDetailsList.forEach((item: any) => {
        if (item.isGroupTotal) return;
        const id = item.VoucherId || item.Voucher_Id || item.VoucherID || item.voucherId;
        if (id && String(id).trim() !== "" && String(id).trim() !== "0") {
          idsSet.add(String(id).trim());
        }
      });
      if (idsSet.size > 0) {
        rawVoucherIds = Array.from(idsSet).join(",");
      }
    }

    if (!rawVoucherIds) {
      this.snackBar.openFromComponent(SnackbarComponent, {
        data: "No vouchers found for this batch.",
        ...this.configSuccess,
      });
      return;
    }

    this.showSpinner = true;

    const requestPayload = {
      Status: "Deleted",
      VoucherIds: String(rawVoucherIds),
      LoginUserId: this.currentUser.userId,
      Remark: this.batchActionRemark,
    };

    this.ReportsService.Save_Voucher_Authorized_Or_Reject(requestPayload).subscribe({
      next: (res: any) => {
        this.showSpinner = false;
        let msg = "Batch deleted successfully";
        if (res && res.length > 0 && res[0].MSG) {
          msg = res[0].MSG;
        } else if (res && res.MSG) {
          msg = res.MSG;
        }

        this.snackBar.openFromComponent(SnackbarComponent, {
          data: msg,
          ...this.configSuccess,
        });

        this.batchActionRemark = "";
        this.onCloseBatchDetailsModal();
        this.onSearchBatch();
      },
      error: (err: any) => {
        this.showSpinner = false;
        console.error("Error deleting batch:", err);
      },
    });
  }

  DateChange() {
    if (this.StartDate > this.EndDate) {
      this.snackBar.openFromComponent(SnackbarComponent, {
        data: "EndDate should be greater than StartDate.",
        ...this.configSuccess,
      });
      this.lmsService
        .Get_FinancialYear({ Id: this.FyearId })
        .subscribe((res: any) => {
          this.StartDate = new Date(
            moment(res[0].fystart).format("MM/DD/YYYY")
          );
          this.EndDate = new Date();
        });
    }
  }

  applyFilter(filterValue: string) {
    this.dataSource.filter = filterValue.trim().toLowerCase();
  }

  onSearchPendingAuth() {
    this.showSpinner = true;
    this.displayedColumnsModel = [
      "Voucher_No",
      "Voucher_Status",
      "Voucher_Type",
      "Voucher_Date",
      "Voucher_CreateOn",
      "Voucher_Sub_Type",
      "Amount",
      "Action",
    ];
    const searchParams = {
      LoginUserId: this.currentUser.userId,
      StartDate: this.StartDate,
      EndDate: this.EndDate,
      VoucherType: this.VoucherType,
      VoucherSubType: this.VoucherSubType,
      AmountFrom: this.AmountFrom,
      AmountTo: this.AmountTo,
      Status: this.Status,
    };
    this.ReportsService.Get_UnAuth_Vouchers_List_By_LoginUserId(searchParams).subscribe(
      (response) => {
        this.showSpinner = false;
        console.log(response);
        const data = response?.data || response;
        if (data && data.length > 0) {
          this.JsonData = data;
          this.dataSource = new MatTableDataSource(data);
          setTimeout(() => {
            this.dataSource.sort = this.sort;
            this.dataSource.paginator = this.paginator;
          });
        } else {
          this.dataSource = new MatTableDataSource([]);
          this.snackBar.openFromComponent(SnackbarComponent, {
            data: "No records found",
            ...this.configSuccess,
          });
        }
      },
      (err: any) => {
        this.showSpinner = false;
      }
    );
  }

  onDateChange() {}

  hasAuthorizationPending(): boolean {
    return this.dataSource?.data?.some(
      (row: any) => row.Voucher_Status === "Authorization Pending",
    );
  }

  hasAnyRowSelected(): boolean {
    return this.dataSource?.data?.some((row: any) => row.IsSelected === true);
  }

  OnApproved() {
    $("#AuthorizeRemarkModal").modal("show");
    $("#AuthorizeRemarkModal").css("z-index", "9999");
  }

  ConfirmAuthorizeVouchers() {
    if (!this.AuthorizeRemark || this.AuthorizeRemark.trim() === "") {
      this.snackBar.openFromComponent(SnackbarComponent, {
        data: "Remark is required.",
        ...this.configSuccess,
      });
      return;
    }
    this.showSpinner = true;
    $("#AuthorizeRemarkModal").modal("hide");
    const selectedRows = this.dataSource?.data?.filter(
      (row: any) => row.IsSelected,
    );
    const voucherIds = selectedRows.map((row: any) => row.VoucherId);
    const voucherIdString = voucherIds.join(",");

    const requestPayload = {
      Status: "Authorized",
      VoucherIds: voucherIdString,
      LoginUserId: this.currentUser.userId,
      Remark: this.AuthorizeRemark,
    };

    this.ReportsService.Save_Voucher_Authorized_Or_Reject(
      requestPayload,
    ).subscribe(
      (res: any) => {
        if (res[0].CODE >= 0) {
          this.showSpinner = false;
          this.snackBar.openFromComponent(SnackbarComponent, {
            data: res[0].MSG,
            ...this.configSuccess,
          });
          this.AuthorizeRemark = "";
          this.onSearchPendingAuth();
        } else {
          this.showSpinner = false;
          this.snackBar.openFromComponent(SnackbarComponent, {
            data: res[0].MSG,
            ...this.configSuccess,
          });
        }
      },
      (err: any) => {
        this.showSpinner = false;
      },
    );
  }

  CloseAuthorizeRemarkModal() {
    this.AuthorizeRemark = "";
    $("#AuthorizeRemarkModal").modal("hide");
  }

  OnReject() {
    $("#RejectRemarkModal").modal("show");
    $("#RejectRemarkModal").css("z-index", "9999");
  }

  ConfirmRejectVouchers() {
    if (!this.RejectRemark || this.RejectRemark.trim() === "") {
      this.snackBar.openFromComponent(SnackbarComponent, {
        data: "Remark is required.",
        ...this.configSuccess,
      });
      return;
    }
    this.showSpinner = true;
    $("#RejectRemarkModal").modal("hide");
    const selectedRows = this.dataSource?.data?.filter(
      (row: any) => row.IsSelected,
    );
    const voucherIds = selectedRows.map((row: any) => row.VoucherId);
    const voucherIdString = voucherIds.join(",");

    const requestPayload = {
      Status: "Rejected",
      VoucherIds: voucherIdString,
      LoginUserId: this.currentUser.userId,
      Remark: this.RejectRemark,
    };

    this.ReportsService.Save_Voucher_Authorized_Or_Reject(
      requestPayload,
    ).subscribe(
      (res: any) => {
        if (res[0].CODE >= 0) {
          this.showSpinner = false;
          this.snackBar.openFromComponent(SnackbarComponent, {
            data: res[0].MSG,
            ...this.configSuccess,
          });
          this.RejectRemark = "";
          this.onSearchPendingAuth();
        } else {
          this.showSpinner = false;
          this.snackBar.openFromComponent(SnackbarComponent, {
            data: res[0].MSG,
            ...this.configSuccess,
          });
        }
      },
      (err: any) => {
        this.showSpinner = false;
      },
    );
  }

  CloseRejectRemarkModal() {
    this.RejectRemark = "";
    $("#RejectRemarkModal").modal("hide");
  }

  onViewModalClose(event: any) {
    this.onSearchPendingAuth();
  }

  exportPendingAuthTable(exporter: any) {
    exporter.exportTable("xls", {
      fileName: "Unauthorized Vouchers Detail",
      sheet: "Unauthorized Vouchers Detail",
    });
  }
}
